// extracted by mini-css-extract-plugin
module.exports = {"lds-spinner":"Spinner_lds-spinner__2j8A6","absolute":"Spinner_absolute__2BQKi"};